import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const TextSpanWithForwardedRef = ({
  classes, node, forwardedRef,
}) => {
  const textContainerClassNames = [classes.textContainer];

  return (
    <span
      className={classNames(textContainerClassNames)}
      ref={forwardedRef}
    >
      {node.Name}
    </span>
  );
};

TextSpanWithForwardedRef.propTypes = {
  classes: PropTypes.shape({
    textContainer: PropTypes.string.isRequired,
  }).isRequired,
  node: PropTypes.shape({
    Name: PropTypes.string.isRequired,
    entityType: PropTypes.string.isRequired,
    TrackingStatus: PropTypes.string,
  }).isRequired,
  forwardedRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

TextSpanWithForwardedRef.defaultProps = {
  forwardedRef: null,
};
